import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=18a8aebb&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=18a8aebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8aebb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a8aebb')) {
      api.createRecord('18a8aebb', component.options)
    } else {
      api.reload('18a8aebb', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=18a8aebb&scoped=true&", function () {
      api.rerender('18a8aebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PVv6PT5ZrRrJ/JS/teamMember.vue"
export default component.exports